import { useEffect, useState } from "react";
import JobZImage from "../../../common/jobz-img";
import JobViewPopup from "../../../common/popups/popup-job-view";
import { loadScript } from "../../../../globals/constants";
import { useDispatch, useSelector } from "react-redux";
import apiCall from "../../../../apicall";
import SectionRecordsFilter from "../../public-user/sections/common/section-records-filter";
import TableLoader from "../../../common/tableLoader";
import moment from "moment";
import SectionPagination from "../../public-user/sections/common/section-pagination";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Spinner from "../../../common/spinner";
import Toast from "../../../common/toast";
import { candidateDetails, employerDetails } from "../../../../store/reducers/menu";
import { Helmet } from "react-helmet-async";
import { formatCompanyName } from "../../../../globals/fomat-comapny-name";
import { logEvent_Analytics } from "../../../common/firebase/firebase-analytics-service";

function ReportTimeDetails({ activeTab, isDownloadTimeCSV, empTimeLogsInfo, setEmpTimeLogsInfo, setIsDownloadTimeCSV, handleDownloadTimeCSV }) {
  console.log("activeTabactiveTab", activeTab)
  const { role_type, TOKEN, userInfo } = useSelector((state) => state.menu);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUrl = location.pathname;
  const [timeLogsCurrentPage, setTimeLogsCurrentPage] = useState(1);
  const [rowTimeLogsPerPage, setTimeLogsRowPerPage] = useState(10);
  const [paginationTimeLogsData, setPaginationTimeLogsData] = useState({
    totalElements: 0,
    totalPages: 0,
  });
  const [timeLogsLoader, setTimeLogsLoader] = useState(false);
  const [searchKey, setSearchKey] = useState('');
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "error",
  });
  const [companyName, setCompanyName] = useState('');
  const [tableFilter, setTableFilter] = useState({
    sortType: "createdDate",
    sortDirection: "desc",
    status: "",
    searchKey: "",
    workerType: "All",
    dateFilter: "",
    startDate: "",
    endDate: "",
    companyName: ""
  });
  // const [empTimeLogsInfo, setEmpTimeLogsInfo] = useState({});

  const _filterConfig = {
    prefix: "Showing",
    type: "results",
    isSorting: false,
    total: paginationTimeLogsData?.totalElements,
    showRange: false,
    showingUpto: "",
    paymentFilter: true,
  };

  const displayTimeLogErrErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
    // console.log("error pagination");
    setPaginationTimeLogsData({
      totalElements: 0,
      totalPages: 0,
    });
    setTimeLogsLoader(false);
  };

  const getTimeLogsData = async (endpoint) => {
    try {
      if(!isDownloadTimeCSV){
        setTimeLogsLoader(true);
      }
      const api = `${endpoint}sortBy=${tableFilter?.sortType}&sortDirection=${tableFilter?.sortDirection}&offset=0&page=${isDownloadTimeCSV ? 0 : timeLogsCurrentPage - 1}&size=${isDownloadTimeCSV ? paginationTimeLogsData?.totalElements : rowTimeLogsPerPage}&searchKey=${tableFilter?.searchKey}&applicantType=${tableFilter?.workerType}&dateFilter=${tableFilter?.dateFilter}&startDate=${tableFilter?.startDate ? moment(tableFilter.startDate).format("YYYY-MM-DD") : ""}&endDate=${tableFilter?.endDate ? moment(tableFilter.endDate).format("YYYY-MM-DD") : ""}`;
      const empTimeLogsResponse = await apiCall(api, "GET", null, TOKEN);
      console.log("empTimeLogsResponse---", empTimeLogsResponse);

      if (empTimeLogsResponse?.data?.content?.length > 0) {
        if (isDownloadTimeCSV) {
          handleDownloadTimeCSV(empTimeLogsResponse?.data?.content);
          setIsDownloadTimeCSV(false);
        } else {
          setEmpTimeLogsInfo(empTimeLogsResponse?.data?.content);
          setPaginationTimeLogsData({
            totalElements: empTimeLogsResponse?.data?.totalElements,
            totalPages: empTimeLogsResponse?.data?.totalPages,
          });
        }
        setTimeLogsLoader(false);
      } else if (empTimeLogsResponse?.data?.content?.length === 0) {
        setEmpTimeLogsInfo({});
        setPaginationTimeLogsData({
          totalElements: 0,
          totalPages: 0,
        });
        setTimeLogsLoader(false);
      } else if (empTimeLogsResponse?.response?.status === 401) {
        displayTimeLogErrErrMsg("Your session has expired!!");
      } else {
        displayTimeLogErrErrMsg(empTimeLogsResponse?.response?.data?.message);
      }
    } catch (err) {
      console.log("Error time logs details", err);
      displayTimeLogErrErrMsg("Something went wrong!");
    }
  };

  const getEmpTimeLogsList = () => {
    if (role_type.includes("ROLE_INSTITUTION_ADMIN")) {
      getTimeLogsData('institutions/timeLogs?');
    }else if(role_type?.includes("ROLE_OPENSTAFF_ADMIN") || role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN")){
      getTimeLogsData(`openstaff/jobs/timeLogs?companyName=${tableFilter?.companyName}&`);
    }
  };

  useEffect(() => {
    if(tableFilter?.dateFilter !== 'custom' || (tableFilter?.dateFilter === 'custom' && tableFilter?.startDate && tableFilter?.endDate)){
     getEmpTimeLogsList();
    }
  }, [timeLogsCurrentPage, rowTimeLogsPerPage, tableFilter]);

  useEffect(() => {
    logEvent_Analytics('timelogs_details_screen_web');
  }, [])

  useEffect(() => {
    if(isDownloadTimeCSV){
      getEmpTimeLogsList()
    }
  }, [isDownloadTimeCSV])

  const handleRecordsTimeLogsPerPageChange = (event) => {
    setTimeLogsCurrentPage(1);
    setTimeLogsRowPerPage(event.target.value);
  };

  const handleSearchClick = (e) => {
    if (e.key === "Enter") {
      setTimeLogsCurrentPage(1);
      setTableFilter({
        ...tableFilter,
        searchKey: searchKey
      })
    }
  }

  const handleSearchKeyFunction = () => {
    setTimeLogsCurrentPage(1);
    setTableFilter({
      ...tableFilter,
      searchKey: searchKey
    })
  }

  useEffect(() => {
    loadScript("js/custom.js");
  });

  const navigateToJobDetail = (item) => {
    // dispatch(jobDetailsData({id : item}));
    navigate(`/job-detail/${item}`, { state: { id: item } });
  };

  const formatAddress = (address, city, state, zipCode) => {
    const parts = [address, city, state, zipCode].filter(Boolean);
    return parts.join(", ");
  };

  const calculateLoggedMinutes = (clockInTime, clockOutTime)  => {
    const inTime = new Date(clockInTime);
    const outTime = new Date(clockOutTime);

    const diffInMilliseconds = outTime - inTime;
    const diffInHours = diffInMilliseconds / (1000 * 60 * 60);

    return diffInHours?.toFixed(2);
  }

  const navigateToEmployee = (item) => {
    dispatch(employerDetails({ id: item }))
    navigate(`/comp-detail`, { state: {id: item} });
  };

  const navigateToApplicant = (item) => {
     dispatch(candidateDetails(item))
     navigate(`/can-detail/${item?.userId}`, { state: item })
  }

  const handleCompanyNameClick = (e) =>{
    if (e.key === "Enter") {
        setTimeLogsCurrentPage(1);
        setTableFilter({
            ...tableFilter,
            companyName: companyName
        })
    }
  }

  const handleCompanyNameFunction = () =>{
    setTimeLogsCurrentPage(1);
    setTableFilter({
        ...tableFilter,
        companyName: companyName
      })
  }

  return (
    <>
      {currentUrl?.includes("/reports") && (
        <div>
          <Helmet>
            <title>{`Time Logs Information, Manage Time Logs Details, Time Logs Methods, Time Logs Overview | ${formatCompanyName()}`}</title>
            <meta
              name="description"
              content="Welcome to the Time Logs Details Page! Here, you can manage and update your time logs information securely. This section allows you to add or modify your time logs methods, view your transaction history, and manage billing preferences."
            />
            <meta
              name="keywords"
              content="time logs details, time logs methods "
            />
          </Helmet>
        </div>
      )}
      <div className="mt-5">
        <SectionRecordsFilter
          _config={_filterConfig}
          rowPerPage={rowTimeLogsPerPage}
          handleRecordsPerPageChange={handleRecordsTimeLogsPerPageChange}
          setTableFilter={setTableFilter}
          tableFilter={tableFilter}
          setCurrentPage={setTimeLogsCurrentPage}
          handleSearchClick={handleSearchClick}
          handleSearchKeyFunction={handleSearchKeyFunction}
          handleCompanyNameClick={handleCompanyNameClick}
          handleCompanyNameFunction={handleCompanyNameFunction}
          setPaymentCurrentPage={setTimeLogsCurrentPage}
          setSearchKey={setSearchKey}
          searchKey={searchKey}
          companyName={companyName}
          setCompanyName={setCompanyName}
          currentPage={timeLogsCurrentPage}
          displayTimeLogErrErrMsg={displayTimeLogErrErrMsg}
          activeReportTabs={activeTab}
        />
        <div className="twm-right-section-panel candidate-save-job ">
          <div className="twm-D_table table-responsive">
            <table
              id="time-logs-details-table"
              className="table table-bordered twm-candidate-save-job-list-wrap"
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Worker Type</th>
                  <th>Job Title</th>
                  {(role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                    role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN")) && (
                    <th>Company</th>
                  )}
                  <th>Location</th>
                  <th>Client Name</th>
                  <th>Clock In Time</th>
                  <th>Clock In Location</th>
                  <th>Clock Out Time</th>
                  <th>Clock Out Location</th>
                  <th>Logged Hours</th>
                </tr>
              </thead>
              <tbody>
                {/*1*/}
                {!timeLogsLoader ? (
                  empTimeLogsInfo?.length > 0 ? (
                    empTimeLogsInfo?.map((item) => (
                      <tr>
                        {role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                        role_type?.includes(
                          "ROLE_OPENSTAFF_FINANCIAL_ADMIN"
                        ) ? (
                          currentUrl?.includes("/reports") && (
                            <td style={{ minWidth: "150px", maxWidth: "150px" }}>
                              <div className="twm-candidate-save-job-list">
                                <div className="twm-mid-content">
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      navigateToApplicant(item)
                                    }
                                    className="twm-job-title"
                                  >
                                    <h4>{item?.applicantName || ""}</h4>
                                  </div>
                                </div>
                              </div>
                            </td>
                          )
                        ) : (
                          <td>
                            <div>
                              {" "}
                              {item?.applicantName || "-"}
                            </div>
                          </td>
                        )}
                        <td>
                          <div>
                            {" "}
                            {item?.workerType ? item?.workerType : "-"}
                          </div>
                        </td>
                        <td style={{ minWidth: "200px", maxWidth: "200px" }}>
                          <div className="twm-candidate-save-job-list">
                            <div className="twm-mid-content">
                              {/* <h4>{item?.jobTitle}</h4> */}
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() => navigateToJobDetail(item?.jobId)}
                                className="twm-job-title"
                              >
                                <h4>{item?.jobTitle}</h4>
                              </div>
                            </div>
                          </div>
                        </td>
                        {(role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                          role_type?.includes(
                            "ROLE_OPENSTAFF_FINANCIAL_ADMIN"
                          )) &&
                          currentUrl?.includes("/reports") && (
                            <td style={{ maxWidth: "150", minWidth: "150" }}>
                              <div className="twm-candidate-save-job-list">
                                <div className="twm-mid-content">
                                  {/* <h4>{item?.jobTitle}</h4> */}
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      navigateToEmployee(item?.institutionId)
                                    }
                                    className="twm-job-title"
                                  >
                                    <h4>{item?.companyName}</h4>
                                  </div>
                                </div>
                              </div>
                            </td>
                          )}
                        <td>
                          <div>
                            {" "}
                            {formatAddress(
                              item?.address,
                              item?.city,
                              item?.state,
                              item?.zipCode
                            )}
                          </div>
                        </td>
                        <td>
                          <div>
                            {" "}
                            {item?.customerName ? item?.customerName : "-"}
                          </div>
                        </td>
                        <td>
                          <div>
                            {item?.clockInTime
                              ? moment.utc(item?.clockInTime, "YYYY-MM-DD HH:mm:ss").local().format(
                                  "MM-DD-YYYY HH:mm:ss"
                                )
                              : "-"}
                          </div>
                        </td>
                        <td>
                          <div>
                            {" "}
                            {item?.clockInLocation?.latitude != null &&
                            item?.clockInLocation?.longitude != null
                              ? `${item?.clockInLocation.latitude}, ${item?.clockInLocation.longitude}`
                              : "-"}
                          </div>
                        </td>
                        <td>
                          <div>
                            {item?.clockOutTime
                              ? moment.utc(item?.clockOutTime, "YYYY-MM-DD HH:mm:ss").local().format(
                                  "MM-DD-YYYY HH:mm:ss"
                                )
                              : "-"}
                          </div>
                        </td>
                        <td>
                          <div>
                            {item?.clockOutLocation?.latitude != null &&
                            item?.clockOutLocation?.longitude != null
                              ? `${item?.clockOutLocation.latitude}, ${item?.clockOutLocation.longitude}`
                              : "-"}
                          </div>
                        </td>
                        <td>
                          <div>
                            {item?.clockInTime && item?.clockOutTime
                              ? calculateLoggedMinutes(item?.clockInTime, item?.clockOutTime)
                              : "-"}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={17} style={{ textAlign: "center" }}>
                        No results found.
                      </td>
                    </tr>
                  )
                ) : (
                  <tr>
                    <td colSpan={17} style={{ textAlign: "center" }}>
                      <TableLoader />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <SectionPagination
            currentPage={timeLogsCurrentPage}
            setCurrentPage={setTimeLogsCurrentPage}
            totalPages={paginationTimeLogsData?.totalPages}
          />
        </div>

        {errSuccessMesg?.message != "" ? (
          <Toast message={errSuccessMesg} />
        ) : (
          ""
        )}

        <JobViewPopup />
      </div>
    </>
  );
}

export default ReportTimeDetails;
